<template>
  <div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousTruckView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center style="margin-left: 0.5rem !important"
            >Vehicle Form</b-navbar-brand
          >
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter class="gutr" v-if="vehicleData.vehicleTruckId != ''">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label for="Type">Vehicle Status</label>
                  <model-list-select
                    :isDisabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :list="vehicleStatusList"
                    v-model="vehicleData.isTruckMasterActive"
                    option-value="vehicleStatusV"
                    option-text="vehicleStatusT"
                    placeholder="Select Status"
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!vehicleData.driverId">{{
                  addTruckError5
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="mt-2">
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Firm Name</label>
                  <b-form-input
                    :disabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :formatter="capitalizeAll"
                    id="vehicleNo"
                    name="vehicleNo"
                    v-model="vehicleData.vehicleNo"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!vehicleData.vehicleNo">{{
                  addTruckError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Chassis No.</label>
                  <b-form-input
                    :disabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :formatter="capitalizeAll"
                    id="chassisNo"
                    name="chassisNo"
                    v-model="vehicleData.chassisNo"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!vehicleData.chassisNo">{{
                  addTruckError3
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Vehicle No.(AB-12-A-1234)</label>
                  <b-form-input
                    :disabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :formatter="capitalizeAll"
                    id="regdNo"
                    @input="checkExistingVehicle"
                    name="regdNo"
                    v-model="vehicleData.regdNo"
                  ></b-form-input>
                  <span class="error" v-if="validateSameVehicle == true">{{
                    sameVehicleNoError
                  }}</span>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Model No.</label>
                  <b-form-input
                    :disabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :formatter="capitalizeAll"
                    id="modNo"
                    name="modNo"
                    v-model="vehicleData.modNo"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Engine No.</label>
                  <b-form-input
                    :disabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :formatter="capitalizeAll"
                    id="engineNo"
                    name="engineNo"
                    v-model="vehicleData.engineNo"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
              <md-layout md-flex="100">
              <label>N.PERMIT</label>
              <b-form-input :formatter="capitalizeAll" id="nPermit" name="nPermit" v-model="vehicleData.nPermit"></b-form-input>
              </md-layout>
              </md-layout>-->

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label for="Type">Vehicle Type</label>
                  <model-list-select
                    :isDisabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :list="vehicleTypeMaster"
                    v-model="vehicleData.vehicleTypeId"
                    option-value="vehicleTypeId"
                    option-text="vehicleType"
                    placeholder="Select Vehicle Type "
                  ></model-list-select>
                  <!-- <md-select
                name="vehicleTypeId"
                id="vehicleTypeId"
                v-model="vehicleData.vehicleTypeId"
              >
                <md-option value>Select Type</md-option>
                <md-option
                  v-for="(item,index) in vehicleTypeMaster"
                  :key="index"
                  :value="item.vehicleTypeId"
                >{{item.vehicleType}}</md-option>
                  </md-select>-->
                </md-layout>
                <span class="error" v-if="!vehicleData.vehicleTypeId">{{
                  addTruckError1
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label for="Type">Vehicle Size</label>
                  <model-list-select
                    :isDisabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :list="vehicleSizeMaster"
                    v-model="vehicleData.vehicleSizeId"
                    option-value="vehicleSizeId"
                    option-text="vehicleSize"
                    placeholder="Select Vehicle Size "
                  ></model-list-select>
                  <!-- <md-select
                name="vehicleSizeId"
                id="vehicleSizeId"
                v-model="vehicleData.vehicleSizeId"
              >
                <md-option value>Select Size</md-option>
                <md-option
                  v-for="(item,index) in vehicleSizeMaster"
                  :key="index"
                  :value="item.vehicleSizeId"
                >{{item.vehicleSize}}</md-option>
                  </md-select>-->
                </md-layout>
                <span class="error" v-if="!vehicleData.vehicleSizeId">{{
                  addTruckError2
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Year of Purchase</label>
                  <b-form-input
                    :disabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :formatter="capitalizeAll"
                    id="vmodelYear"
                    name="vmodelYear"
                    v-model="vehicleData.vmodelYear"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label for="Type">Hub</label>
                  <model-list-select
                    :isDisabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :list="hubDetails"
                    v-model="vehicleData.hubId"
                    option-value="hubId"
                    option-text="hubName"
                    placeholder="Select Hub"
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!vehicleData.driverId">{{
                  addTruckError5
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label for="Type">Vehicle Active/Inactive</label>
                  <model-list-select
                    :isDisabled="
                      vehicleData.vehicleTruckId > 0 &&
                      $sessionsStorage.get('designation') != 'Admin'
                    "
                    :list="vehicleActiveInactive"
                    v-model="vehicleData.vehicleActiveInactiveId"
                    option-value="vehicleActiveInactiveV"
                    option-text="vehicleActiveInactiveT"
                    placeholder="Active / Inactive "
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                    <md-layout md-flex="100">
                    <label>MV Tax</label>
                    <b-form-input :formatter="capitalizeAll" id="mvTax" name="mvTax" v-model="vehicleData.mvTax"></b-form-input>
                      </md-layout>
                    </md-layout>-->
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30" v-if="vehicleData.vehicleTruckId != ''">
                <md-layout md-flex="100">
                  <label for="Type">Vehicle Driver</label>
                  <md-select
                    name="driverId"
                    id="driverId"
                    v-model="vehicleData.driverId"
                    disabled
                  >
                    <md-option value>Select Driver</md-option>
                    <md-option
                      v-for="(item, index) in driverNameDetail"
                      :key="index"
                      :value="item.driverId"
                      >{{ item.driverName }}</md-option
                    >
                  </md-select>
                </md-layout>
                <!-- <span class="error" v-if="!vehicleData.driverId">{{addTruckError4}}</span> -->
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <md-layout md-flex="100">
                  <label>Insurance Validity</label>
                  <b-form-input :formatter="capitalizeAll" id="insurValid" name="insurValid" v-model="vehicleData.insurValid"></b-form-input>
                  </md-layout>
                  </md-layout>-->
            </md-layout>

            <!-- <md-layout md-gutter v-if="vehicleData.uploadVehicleDoc!=''">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout
                      md-flex="20"
                      v-if="viewVehicledDoc.length>0"
                      v-for="(item,index) in viewVehicledDoc"
                      :key="index"
                      >
                      <a
                        :href="'http://13.229.240.246/VehicleMaster/'+item"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      </md-layout>
                      </md-layout>-->
            <div class="mt-4">
              <div>
                <b><u>Vehicle Documents</u></b>
              </div>
              <div class="table-responsive tableMain">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 400px">Document Name</th>
                      <th scope="col">Upload</th>
                      <th scope="col">View Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(items, index) in showDocumentArray" :key="index">
                      <td>{{ items.show }}</td>
                      <td>
                        <md-input-container>
                          <label>Click to Upload {{ items.show }}</label>
                          <md-file
                            :name="items.value"
                            :id="items.value"
                            v-model="vehicleData[items.value]"
                            @selected="onFileChange(items.value)"
                            :multiple="items.show == 'Other Document' ? true : false"
                          ></md-file>
                        </md-input-container>
                      </td>
                      <td>
                        <a
                          v-if="
                            items.show != 'Other Document' &&
                            vehicleData[items.value] != ''
                          "
                          href="javascript:void(0)"
                          @click="openSignedDocument(getS3Key(items.url, vehicleData[items.value]))"
                          >View {{ items.show }}</a
                        >
                        <div
                          v-else-if="
                            items.show == 'Other Document' &&
                            vehicleData[items.value] != ''
                          "
                          v-for="(item, index) in viewVehicledDoc"
                          :key="index"
                        >
                          <a href="javascript:void(0)" @click="openSignedDocument(getS3Key(items.url, item))"
                            >Document - {{ index + 1 }}</a
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <b-card class="mt-5" style="background: whiteSmoke">
                <b-card-text>
                  <!-- <div>
                      <span style="margin-left:45px">
                        <b>
                          <u>Vehicle Documents</u>
                        </b>
                      </span>
                    </div> -->
                  <!-- <md-layout
                      md-gutter
                      v-for="(items, index) in showDocumentArray"
                      :key="index"
                      class="gutr"
                    >
                    
                      <md-layout :md-flex="items.flex">
                        <span>{{items.show}}</span>
                      </md-layout>
                      <md-layout md-flex="5">
                        <h3>:</h3>
                      </md-layout>

                      <md-layout md-flex="40" style="margin-top:-2%">
                        <md-layout md-flex="100">
                          <md-input-container>
                            <label>Click to Upload {{items.show}}</label>
                            <md-file
                              :name="items.value"
                              :id="items.value"
                              v-model="vehicleData[items.value]"
                              @selected="onFileChange(items.value)"
                              :multiple="(items.show=='Other Document')?true:false"
                            ></md-file>
                          </md-input-container>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5">


                              </md-layout>

                      <md-layout
                        :md-flex="15"
                        v-if="items.show!='Other Document' && vehicleData[items.value]!=''"
                      >
                        <a
                          :href="items.url + vehicleData[items.value]"
                          target="_blank"
                        >View {{items.show}}</a>
                      </md-layout>
                      <md-layout
                        md-flex="10"
                        v-else-if="items.show=='Other Document' && vehicleData[items.value]!=''"
                        v-for="(item,index) in viewVehicledDoc"
                        :key="index"
                      >
                        <a :href="items.url + item" target="_blank" download>Document - {{index+1}}</a>
                      </md-layout>
                    </md-layout> -->
                  <div>
                    <md-layout md-gutter>
                      <md-layout md-flex="30">
                        <label>National Permit Authorization Validity</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          v-model="vehicleData.NPAValidity"
                          id="Date"
                          width="100%"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="30">
                        <label>National Permit PART AB Validity</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          v-model="vehicleData.NPValidity"
                          id="Date"
                          width="100%"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="30">
                        <label>FITNESS CERTIFICATE Validity</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          v-model="vehicleData.FCValidity"
                          id="Date"
                          width="100%"
                        ></date-picker>
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter>
                      <md-layout md-flex="30">
                        <label>Pollution Certificate Validity</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          placeholder="Date"
                          v-model="vehicleData.polutionValidity"
                          id="Date"
                          width="100%"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="30">
                        <label>INSURANCE Validity</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          placeholder="Date"
                          v-model="vehicleData.INValidity"
                          id="Date"
                          width="100%"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="30">
                        <label>RC Validity</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          placeholder="Date"
                          v-model="vehicleData.RCValidity"
                          id="Date"
                          width="100%"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="30">
                        <label>MV TAX Validity Date</label>
                        <date-picker
                          :format="selectDateFormat"
                          lang="en"
                          placeholder="Date"
                          v-model="vehicleData.MUValidity"
                          id="Date"
                          width="100%"
                        ></date-picker>
                      </md-layout>
                    </md-layout>
                  </div>
                  <md-layout md-gutter class="mt-4">
                    <span
                      class="error"
                      v-if="vehicleData.National_Permit_Authorization == ''"
                      >{{ NPAError }}</span
                    >
                  </md-layout>
                  <md-layout md-gutter>
                    <span
                      class="error"
                      v-if="vehicleData.National_Permit_PART_AB == ''"
                      >{{ NPError }}</span
                    >
                  </md-layout>
                  <md-layout md-gutter>
                    <span class="error" v-if="vehicleData.FITNESS_CERTIFICATE == ''">{{
                      FCError
                    }}</span>
                  </md-layout>
                  <md-layout md-gutter>
                    <span class="error" v-if="vehicleData.INSURANCE == ''">{{
                      INError
                    }}</span>
                  </md-layout>
                  <md-layout md-gutter>
                    <span class="error" v-if="vehicleData.MU_TAX == ''">{{
                      MUError
                    }}</span>
                  </md-layout>
                  <md-layout md-gutter>
                    <span class="error" v-if="vehicleData.RC == ''">{{ RCError }}</span>
                  </md-layout>
                  <md-layout md-gutter>
                    <span class="error" v-if="vehicleData.pollutionCertificate == ''">{{
                      pollutionError
                    }}</span>
                  </md-layout>
                </b-card-text>
              </b-card>
            </div>

            <md-layout md-gutter class="mt-3">
              <md-layout class="justify-content-center">
                <b-button
                  variant="primary"
                  class="smbutnWidth mt-3"
                  @click="addTruckDetails"
                  id="addButtonLoader"
                  >Save</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/truckMaster");
      if (globalPermissionStatus("vehicleMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("vehicleMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.getTypeSize();
      this.viewTypeSize();
      this.vehicleDriver();
      this.vehicleHub();
      this.getDocData();

      if (
        this.$sessionsStorage.get("editVehicleId") != "" &&
        this.$sessionsStorage.get("editVehicleId") != undefined
      ) {
        this.$store.dispatch("setCurrentRoute", "/vehicle/truckMaster/");

        this.viewEditVehicle();
      }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      alert: {
        content:
          this.$sessionsStorage.get("editVehicleId") != "" &&
          this.$sessionsStorage.get("editVehicleId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      vehicleData: {
        vehicleTruckId: "",
        vehicleId: "",
        vehicleNo: "PRIDEL Pvt. Ltd.",
        vehicleTypeId: "",
        vehicleActiveInactiveId: "1",
        vehicleSizeId: "",
        driverId: "",
        regdNo: "",
        modNo: "",
        engineNo: "",
        chassisNo: "",
        nPermit: "",
        mvTax: "",
        insurValid: "",
        hubName: "",
        hubId: "",
        National_Permit_Authorization: "",
        RC: "",
        pollutionCertificate: "",
        National_Permit_PART_AB: "",
        FITNESS_CERTIFICATE: "",
        INSURANCE: "",
        MU_TAX: "",
        uploadVehicleDoc: "",
        vmodelYear: "",
        isTruckMasterActive: "",
        NPAValidity: "",
        NPValidity: "",
        FCValidity: "",
        INValidity: "",
        MUValidity: "",
        polutionValidity: "",
        RCValidity: "",
      },
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editVehicleId") != "" &&
          this.$sessionsStorage.get("editVehicleId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editVehicleId") != "" &&
          this.$sessionsStorage.get("editVehicleId") != undefined
            ? "Update"
            : "New",
      },
      vehicleStatusList: [
        {
          vehicleStatusV: "1",
          vehicleStatusT: "Available",
        },
        {
          vehicleStatusV: "0",
          vehicleStatusT: "Booked",
        },
      ],
      vehicleActiveInactive: [
        {
          vehicleActiveInactiveV: "1",
          vehicleActiveInactiveT: "Active",
        },
        {
          vehicleActiveInactiveV: "2",
          vehicleActiveInactiveT: "Inactive",
        },
      ],
      hubDetails: [],
      driverNameDetail: [],
      vehicleTypeMaster: [],
      vehicleSizeMaster: [],
      truckMasterDetails: [],
      showDocumentArray: [],
      veiwVehicleMaster: [
        {
          SrNo: "1",
        },
      ],
      sameVehicleNoError: "",
      validateSameVehicle: false,
      validate: true,
      addTruckError: "",
      addTruckError1: "",
      addTruckError2: "",
      addTruckError3: "",
      addTruckError4: "",
      addTruckError5: "",
      NPAError: "",
      NPError: "",
      FCError: "",
      INError: "",
      MUError: "",
      RCError: "",
      pollutionError: "",
      NPAValidityError: "",
      NPValidityError: "",
      FCValidityError: "",
      INValidityError: "",
      MUValidityError: "",
      uploadError: "",
      uploadVehicleDocEr: "",
    };
  },

  mounted() {
    this.JqueryFun();
  },
  beforeDestroy() {
    this.$sessionsStorage.set("editVehicleId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
  },
  computed: {
    viewVehicledDoc() {
      return this.vehicleData.uploadVehicleDoc.split(",");
    },
  },
  methods: {
    checkExistingVehicle() {
      let sameNo = this.truckMasterDetails.filter((x) => {
        return x.regdNo == this.vehicleData.regdNo;
      });
      if (sameNo.length > 0) {
        $("#regdNo").focus();
        this.sameVehicleNoError = " Vehicle No. Already Exists";
        this.validateSameVehicle = true;
        console.log("jh");
      } else {
        this.sameVehicleNoError = "";
        this.validateSameVehicle = false;
      }
    },
    JqueryFun() {
      return $(function () {
        return $("#vehicleMaster").DataTable();
      });
    },
    previousTruckView() {
      this.$router.push({
        path: "/vehicle/viewVehicleDetail",
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },
    onFileChange(value) {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`${value}[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileVehicleMaster.php`, formData, config)
        .then((result) => {
          this.vehicleData[value] = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    // onFileChange1(value) {
    //   var files = event.target.files || event.dataTransfer.files;

    //   var formData = new FormData();
    //   for (let i = 0; i < files.length; i++) {
    //     formData.append("file[]", files[i]);
    //   }
    //   const config = {
    //     headers: { "content-type": "multipart/form-data" }
    //   };

    //   axios
    //     .post(`${URL_BASE}/uploadFileVehicleMaster.php`, formData, config)
    //     .then(result => {
    //       this.vehicleData.uploadVehicleDoc = result.data;
    //       // console.log("fdsf", result.data);
    //     })
    //     .catch(err => {
    //       throw err;
    //     });
    // },

    checkAvailability() {
      this.$router.push({
        path: "/vehicle/vehicleAvailability",
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },

    expandEvent(e) {
      e.preventDefault();
    },

    validateAddTruckForm() {
      let validate_new = true;

      if (this.vehicleData.vehicleNo == "") {
        $("#vehicleNo").focus();
        this.addTruckError = "Enter Vehicle No.";
        validate_new = false;
      }
      if (this.vehicleData.vehicleTypeId == "") {
        $("#vehicleTypeId").focus();
        this.addTruckError1 = "Select Vehicle Type";
        validate_new = false;
      }
      if (this.vehicleData.vehicleSizeId == "") {
        $("#vehicleSizeId").focus();
        this.addTruckError2 = "Select Vehicle Size";
        validate_new = false;
      }
      if (this.validateSameVehicle == true && this.vehicleData.vehicleTruckId == "") {
        $("#regdNo").focus();
        this.sameVehicleNoError = "Vehicle No. Already Exists";
        validate_new = false;
      }

      if (this.vehicleData.chassisNo == "") {
        $("#chassisNo").focus();
        this.addTruckError3 = "Enter Chassis No.";
        validate_new = false;
      }
      // if (this.vehicleData.driverId == "") {
      //   $("#driverId").focus();
      //   this.addTruckError4 = "Select Driver";
      //   validate_new = false;
      // }
      // if (this.vehicleData.hubId == "") {
      //   $("#hubId").focus();
      //   this.addTruckError5 = "Select Hub";
      //   validate_new = false;
      // }

      // if (this.vehicleData.National_Permit_Authorization == "") {
      //   this.NPAError = "Upload National Permit Authorization";
      //   validate_new = false;
      // }
      // if (this.vehicleData.National_Permit_PART_AB == "") {
      //   this.NPError = "Upload National Permit PART AB";
      //   validate_new = false;
      // }
      // if (this.vehicleData.FITNESS_CERTIFICATE == "") {
      //   this.FCError = "Upload FITNESS CERTIFICATE";
      //   validate_new = false;
      // }
      // if (this.vehicleData.INSURANCE == "") {
      //   this.INError = "Upload INSURANCE";
      //   validate_new = false;
      // }
      // if (this.vehicleData.MU_TAX == "") {
      //   this.MUError = "Upload MU TAX";
      //   validate_new = false;
      // }

      // if (this.vehicleData.RC == "") {
      //   this.RCError = "Upload RC";
      //   validate_new = false;
      // }
      // if (this.vehicleData.pollutionCertificate == "") {
      //   this.pollutionError = "Upload Pollution Certificate";
      //   validate_new = false;
      // }

      // if (
      //   this.clientDetail.isKYC == "Yes" &&
      //   this.clientDetail.aadharCard == ""
      // ) {
      //   this.aadharError = "Upload Your GST document";
      //   validate_new = false;
      // }

      // if (this.viewVehicledDoc.length < 5) {
      //   this.uploadError = "Upload All Mandatory Documents";
      //   validate_new = false;
      // } else {
      //   this.uploadError = "";
      // }

      // if (this.vehicleData.uploadVehicleDoc == "") {
      //   $("#uploadVehicleDoc").focus();
      //   this.uploadVehicleDocEr = "";
      //   validate_new = false;
      // }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    onClose(type) {
      this.$router.push({
        path: "/vehicle/viewVehicleDetail",
      });
    },

    viewEditVehicle() {
      let edit_Vehicle = {
        edit: "edit",
        vehicleTruckId: this.$sessionsStorage.get("editVehicleId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewEditVehicle.php`,
        data: JSON.stringify(edit_Vehicle),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            Object.keys(this.vehicleData).map((x) => {
              this.vehicleData[x] = data.editVehicle[0][x] || "";
            });
          }
        })
        .catch((error) => {});
    },

    addTruckDetails() {
      this.validateAddTruckForm();

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addTruckDetails.php`,
          data: JSON.stringify(this.vehicleData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            console.log("result=>", result);
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              Object.keys(this.vehicleData).map((x) => {
                this.vehicleData[x] = "";
              });
              this.addTruckError = "";
              this.addTruckError1 = "";
              this.addTruckError2 = "";
              this.addTruckError3 = "";
              this.addTruckError4 = "";
              this.addTruckError5 = "";
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },

    vehicleDriver() {
      let vehicle_drive = {
        driverName: "driverName",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchDriver.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.driverNameDetail = data.driverDetail;
          }
        })
        .catch((error) => {});
    },

    vehicleHub() {
      let vehicle_hub = {
        hubName: "hubName",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchHubToVehicle.php`,
        data: JSON.stringify(vehicle_hub),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.hubDetails = data.hubDetail;
          }
        })
        .catch((error) => {});
    },

    getTypeSize() {
      let type_Size = {
        truckTS: "truckTS",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchTypeSizeTruck.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            this.vehicleTypeMaster = data.truckTypeDetails;
            this.vehicleSizeMaster = data.truckSizeDetails;
            this.truckMasterDetails = data.truckMasterDetails;
          }
        })
        .catch((error) => {});
    },

    viewTypeSize() {
      let type_Size = {
        truckTypesize: "truckTypesize",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewTruckMaster.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.veiwVehicleMaster = data.truckMasterDetails;
            //console.log("fsf",data.truckSizeDetails)
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    getDocData() {
      this.showDocumentArray = [
        {
          value: "National_Permit_Authorization",
          show: "National Permit Authorization",
          flex: "15",
          url: `${this.docURL}/Vehicle/National_Permit_Authorization/`,
        },
        {
          value: "National_Permit_PART_AB",
          show: "National Permit PART AB",
          flex: "15",
          url: `${this.docURL}/Vehicle/NationalPermit/`,
        },
        {
          value: "FITNESS_CERTIFICATE",
          show: "FITNESS CERTIFICATE",
          flex: "15",
          url: `${this.docURL}/Vehicle/FITNESS/`,
        },
        {
          value: "INSURANCE",
          show: "INSURANCE ",
          flex: "15",
          url: `${this.docURL}/Vehicle/INSURANCE/`,
        },
        {
          value: "MU_TAX",
          show: "MV TAX ",
          flex: "15",
          url: `${this.docURL}/Vehicle/MUTAX/`,
        },

        {
          value: "RC",
          show: "Vehicle registration certificate",
          flex: "15",
          url: `${this.docURL}/Vehicle/RC/`,
        },
        {
          value: "pollutionCertificate",
          show: "Pollution Certificate",
          flex: "15",
          url: `${this.docURL}/Vehicle/pollutionCertificate/`,
        },
        {
          value: "uploadVehicleDoc",
          show: "Other Document",
          flex: "15",
          url: `${this.docURL}/Vehicle/Other/`,
        },
      ];
    },
    getS3Key(url, file) {
      if (!url || !file) return "";
      const bucketBase = "https://pridel-document.s3.ap-south-1.amazonaws.com/";
      const fullUrl = url + file;
      return fullUrl.replace(bucketBase, "");
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 15% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// truckMaster.vue?49068f92